<template>
  <div>
    <!-- Troubleshooting card -->
    <div :class="['ts-card',
      needsTroubleshooting === true  ? 'ts-card-yes' :
      needsTroubleshooting === false ? 'ts-card-no'  : ''
    ]">
      <div class="ts-card-header">
        <div class="ts-card-icon">
          <font-awesome-icon :icon="['fas', 'clipboard-list-check']" size="xl" fixed-width />
        </div>
        <div class="ts-card-text">
          <div class="ts-card-title">¿Requiere revisar el troubleshooting?</div>
          <div class="ts-card-sub">Activa para abrir el diagnóstico</div>
        </div>
        <div class="d-flex">
          <b-button
            class="mr-2"
            :variant="needsTroubleshooting === true ? 'primary' : 'outline-secondary'"
            size="sm"
            style="width: 55px;"
            @click="onChangeTs(true)"
          >
            <span>Sí</span>
          </b-button>
          <b-button
            :variant="needsTroubleshooting === false ? 'primary' : 'outline-secondary'"
            size="sm"
            style="width: 55px;"
            @click="onChangeTs(false)"
          >
            No
          </b-button>
        </div>
      </div>
        <div v-if="needsTroubleshooting === true">
        <div class="section-divider" style="margin-top:20px">
          <span class="text-success">
            <a @click="showTsModal= true" style="text-decoration: underline;" class="clickable">
              <font-awesome-icon :icon="['far', 'check-circle']" fixed-width />
              Ver Troubleshooting
            </a>
          </span>
        </div>
        <b-alert variant="success" :show="tsIsSolved === 'Sí'" class="mb-0" >
          <div class="d-flex align-items-center justify-content-center text-center mb-0" style="font-weight: 550;">
            <span>Se marcó como solucionado el problema, puede proceder con la creación de la orden</span>
          </div>
        </b-alert>
      </div>
    </div>

    <!-- Modal Troubleshooting -->
    <b-modal
      v-model="showTsModal"
      title="Guía de diagnóstico"
      size="lg"
      :hide-footer="true"
      centered
      no-close-on-backdrop
      @hide="onHideTsModal"
    >
      <div class="pt-1">
        <b-alert v-if="!form.service.system_type" variant="warning" show class="text-center">
          <font-awesome-icon :icon="['far', 'exclamation-triangle']" fixed-width />
          Debe seleccionar el <b>tipo de equipo</b> para continuar
        </b-alert>

        <b-row class="mb-2">
          <b-col>
            <b-form-group>
              <template #label>
                <span>Tipo de problema</span><span class="asterisk">*</span>
              </template>
              <b-select
                v-model="form.service.problem_type"
                :options="problemTypeOptions"
                :disabled="!form.service.system_type"
              >
                <template v-slot:first>
                  <option :value="null">-- Seleccionar --</option>
                </template>
              </b-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-alert v-if="form.service.system_type && form.service.problem_type && !tsAnswers.length" variant="danger" show class="text-center">
          No hay preguntas de diagnóstico para este equipo y problema
        </b-alert>

        <div v-if="form.service.system_type && form.service.problem_type">
          <div v-if="tsAnswers.length != 0" class="ts-divider-label">Preguntas de diagnóstico</div>

          <!-- questions -->
          <div
            v-for="(question, idx) in tsAnswers"
            :key="idx"
            class="ts-question-row"
          >
            <div class="ts-q-text">
              <span class="ts-q-num">{{ idx + 1 }}</span>
              <span>{{ question.text }}</span>
            </div>
            <div class="d-flex">
              <b-button
                type="button"
                size="sm"
                style="width: 45px;"
                :variant="question.answer === 'Sí' ? 'primary' : 'outline-secondary'"
                @click="setTsAnswer(idx, 'Sí')"
              >
                Sí
              </b-button>
              <b-button
                type="button"
                size="sm"
                style="width: 45px;"
                :variant="question.answer === 'No' ? 'primary' : 'outline-secondary'"
                class="ml-2"
                @click="setTsAnswer(idx, 'No')"
              >
                No
              </b-button>
            </div>
          </div>

          <div class="mt-3" v-if="tsAnswers.length > 0">
            <div class="d-flex align-items-center">
              <p class="pb-0"><span>¿Se solucionó el problema?</span><span class="asterisk">*</span></p>
              <b-form-group>
                <div class="d-flex ml-2" style="gap: 8px;">
                  <b-button
                    type="button"
                    size="sm"
                    style="width: 55px;"
                    :variant="tsIsSolved === 'Sí' ? 'primary' : 'outline-secondary'"
                    @click="tsIsSolved = 'Sí'"
                  >
                    Sí
                  </b-button>
                  <b-button
                    type="button"
                    size="sm"
                    style="width: 55px;"
                    :variant="tsIsSolved === 'No' ? 'primary' : 'outline-secondary'"
                    @click="tsIsSolved = 'No'"
                  >
                    No
                  </b-button>
                </div>
              </b-form-group>
            </div>

            <b-alert :show="tsIsSolved === 'Sí'" variant="info" class="mt-0 mb-2">
              <font-awesome-icon :icon="['far', 'info-circle']" size="lg" fixed-width />
              <span class="pl-1">
                Se marcó como solucionado el problema, <b>se va a proceder con la creación y registro de la orden de servicio</b>
              </span>
            </b-alert>

            <b-form-group v-if="tsIsSolved === 'Sí'">
              <template #label>
                <span>Comentario de solución</span>
                <span class="asterisk">*</span>
              </template>
              <b-form-textarea
                v-model="tsSolvedComment"
                rows="3"
                :state="tsSolvedComment && tsSolvedComment.length > 10 ? true : false"
                placeholder="Describa la solución aplicada"
              />
            </b-form-group>
          </div>
        </div>

        <div class="float-right d-flex mt-2">
          <!-- <b-button type="button" variant="outline-danger" @click="showTsModal = false">Cancelar</b-button> -->
          <b-button
            type="button"
            variant="outline-success"
            class="ml-2"
            :disabled="!validSaveTs"
            @click="saveTsAndClose"
          >
            Guardar y cerrar
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'TroubleshootingModal',
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showTsModal: false,
      tsAnswers: [],
      tsIsSolved: 'No',
      tsSolvedComment: '',
      needsTroubleshooting: null,
      questionsMap: {
        "Abatible o Plegable": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Corredizo": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Puerta Automática": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Seccional": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Cortina": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Barrera": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "instruccion", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No abre": [
            { type: "instruccion", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" },
            { type: "pregunta", text: "¿Sistema manual bien bloqueado?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Control de Acceso": {
          "No cierra":[
            { type: "pregunta", text: "¿Sensor despejado?" }
          ],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" }
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" }
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Cajeros": {
          "No cierra":[],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Fue retirado el exceso de dinero?" },
            { type: "pregunta", text: "¿Tiene disponibilidad de consumibles?" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" },
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Seccional o Elevadizo": {
          "No cierra":[],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Fue retirado el exceso de dinero?" },
            { type: "pregunta", text: "¿Tiene disponibilidad de consumibles?" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" },
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Terminal de entrada/salida": {
          "No cierra":[],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Fue retirado el exceso de dinero?" },
            { type: "pregunta", text: "¿Tiene disponibilidad de consumibles?" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" },
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Terminal de entrada/salida": {
          "No cierra":[],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Fue retirado el exceso de dinero?" },
            { type: "pregunta", text: "¿Tiene disponibilidad de consumibles?" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" },
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [
            { type: "pregunta", text: "Poner manualmente ¿está suave?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Existen obstáculos o suciedad?" }
          ],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        },
        "Computadora, servidor o caja manual": {
          "No cierra":[],
          "No abre": [],
          "No funciona": [
            { type: "pregunta", text: "¿Breaker encendido?" },
            { type: "instruccion", text: "Apagar y encender breaker" },
            { type: "pregunta", text: "¿Baterías o UPS están respondiendo?" },
            { type: "pregunta", text: "Obstáculos o atascos" },
            { type: "pregunta", text: "¿Puede reiniciar y probar?" },
            { type: "pregunta", text: "¿las credenciales son correctas?" },
            { type: "pregunta", text: "¿Usuario le falta capacitación?" },
          ],
          "Error al detectar o sensar": [
            { type: "pregunta", text: "¿Sensor o lente limpio y despejado?" },
            { type: "pregunta", text: "¿Hay obstáculos o atascos?" },
            { type: "pregunta", text: "¿Hay internet o enlace de comunicación?" },
            { type: "pregunta", text: "¿Abonado está correctamente logueado?" },
          ],
          "Sonidos anormales": [
            { type: "pregunta", text: "¿Representa un peligro? Desconectar" }
          ],
          "Lento": [],
          "Objeto con daño evidente": [
            { type: "pregunta", text: "Identificar este objeto, foto" },
            { type: "pregunta", text: "Resguardar en caso de ser posible" }
          ],
          "Accidente mayor": [
            { type: "instruccion", text: "Desconectar electricidad" },
            { type: "pregunta", text: "¿Se requiere equipo pesado?" },
            { type: "pregunta", text: "Enviar asesor a valorar, ¿técnico puede hacer algo?" },
            { type: "pregunta", text: "¿Visitar para despejar paso?, se cotizará" }
          ],
          "Huele a Quemado o Ruidos fuertes": [
            { type: "instruccion", text: "Desconectar electricidad, se enviará técnico" }
          ]
        }
      }
    }
  },
  watch: {
    'form.service.system_type' () {
      this.tsAnswers = this.formatTsSolution()
      // NEXT: fetch, format, etc questions
    },
    'form.service.problem_type' () {
      this.tsAnswers = this.formatTsSolution()
      // NEXT: fetch, format, etc questions
    },
    showTsModal (newVal) {
      if (!newVal) return
      const { ts_solution } = this.form.service
      if (!Object.keys(ts_solution).length) return

      this.tsIsSolved = ts_solution.is_solved
      this.tsSolvedComment = ts_solution.solved_comment
      this.tsAnswers = JSON.parse(JSON.stringify(ts_solution.questions))
    }
  },
  computed: {
    validSaveTs () {
      const { system_type, problem_type } = this.form.service
      if (!system_type || !problem_type) return false
      if (system_type && problem_type && this.tsAnswers.length === 0) return true

      const answers = this.tsAnswers.map(q => q.answer)
      if (answers.every(a => a === null)) return false

      if (this.tsIsSolved === 'Sí' && (!this.tsSolvedComment || this.tsSolvedComment.length <= 10)) return false

      return true
    },
    problemTypeOptions () {
      if (!this.form.service.system_type) return []

      const typeOptionsObject = this.questionsMap[this.form.service.system_type] || {}
      const options = []

      for (const [key, value] of Object.entries(typeOptionsObject)) {
        if (value.length > 0) {
          options.push({ value: key, text: key })
        }
      }

      return options
    }
  },
  methods: {
    formatTsSolution () {
      this.tsIsSolved = 'No'
      this.tsSolvedComment = ''
      const { system_type, problem_type } = this.form.service

      if (!system_type || !problem_type) return []

      const questions = this.questionsMap[system_type][problem_type] || []

      return  questions.map(question => ({
        ...question,
        answer: null
      }))
    },
    onChangeTs (val) {
      if (val === true) {
        this.showTsModal = true
        return
      }

      this.needsTroubleshooting = val
      this.resetTsState()
    },
    onHideTsModal () {
      if (this.needsTroubleshooting) return
      if (Object.keys(this.form.service.ts_solution).length > 0) return

      this.resetTsState()
    },
    setTsAnswer (idx, val) {
      const tsAnswer = this.tsAnswers[idx]
      tsAnswer.answer = val

      this.$set(this.tsAnswers, idx, tsAnswer)
    },
    saveTsAndClose () {
      const tsSolution = {
        is_solved: this.tsIsSolved,
        solved_comment: this.tsSolvedComment,
        questions: JSON.parse(JSON.stringify(this.tsAnswers))
      }
      this.needsTroubleshooting = true
      this.$emit('save-ts-solution', tsSolution)
      this.showTsModal = false
    },
    resetTsState () {
      this.form.service.problem_type = null
      this.form.service.ts_solution = {}
      this.tsIsSolved = 'No'
      this.tsSolvedComment = null
      this.tsAnswers = []
    }
  }
}
</script>

<style scoped>
  .ts-card { border: 1px solid #1d58b7; border-radius: 9px; padding: 13px 16px; background: #fafaf8; transition: border-color 0.15s; }
  .ts-card-header { display: flex; align-items: center; gap: 12px;}
  .ts-card-yes { border-color: #29a745; background: #f0fdf4; }
  .ts-card-icon { width: 34px; height: 34px; border-radius: 8px; background: #d4d4d4; color: #1d58b7; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .ts-card-text { flex: 1; }
  .ts-card-title { font-size: 0.875rem; font-weight: 600; color: #1a1a1a; }
  .ts-card-sub { font-size: 0.74rem; color: #999; margin-top: 2px; }

  .ts-divider-label { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #aaa; margin: 4px 0 12px; }
  .ts-question-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 11px 14px; border: 1px solid #e5e3dc; border-radius: 8px; margin-bottom: 7px; background: #fff; transition: opacity 0.2s, background 0.2s; }
  .ts-q-text { display: flex; align-items: center; gap: 10px; font-size: 0.84rem; color: #374151; flex: 1; }
  .ts-q-num { width: 20px; height: 20px; border-radius: 50%; background: #f0ede6; color: #888; display: flex; align-items: center; justify-content: center; font-size: 0.68rem; font-weight: 700; flex-shrink: 0; }

  .section-divider { display: flex; align-items: center; gap: 10px; margin: 16px 0; }
  .section-divider span { font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: #aaa; white-space: nowrap; }
  .section-divider::before, .section-divider::after { content: ''; flex: 1; height: 1px; background: #eeede8; }
</style>